module.exports = __webpack_public_path__ + "static/apple-icon-72x72-5dfd3b1e8057609c1820887e99e5c806.png";